import { ChevronRight } from 'lucide-react';
import type { CanvasGroup, GroupBounds } from '../../types';
import { COLLAPSED_GROUP_WIDTH, COLLAPSED_GROUP_HEIGHT } from '../../types';
import { useGroupBoxInteraction } from './useGroupBoxInteraction';

export interface CanvasGroupBoxCollapsedProps {
  group: CanvasGroup;
  bounds: GroupBounds;
}

export function CanvasGroupBoxCollapsed({ group, bounds }: CanvasGroupBoxCollapsedProps) {
  const {
    borderColor, borderWidth,
    handlePointerDown, handleClick, handleDoubleClick, handleContextMenu, handleCollapseClick,
  } = useGroupBoxInteraction(group.id, group.layerId, group.borderColor, group.borderWidth);

  return (
    <div
      data-canvas-entity
      data-canvas-group={group.id}
      style={{
        position: 'absolute',
        left: bounds.x,
        top: bounds.y,
        width: COLLAPSED_GROUP_WIDTH,
        height: COLLAPSED_GROUP_HEIGHT,
        border: `${borderWidth}px solid ${borderColor}`,
        borderRadius: 8,
        cursor: 'grab',
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        padding: '0 8px',
        userSelect: 'none',
        backgroundColor: '#f8fafc',
      }}
      onPointerDown={handlePointerDown}
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
      onContextMenu={handleContextMenu}
    >
      <button
        data-group-collapse-btn
        onClick={handleCollapseClick}
        style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', display: 'flex', color: '#64748b' }}
      >
        <ChevronRight size={16} />
      </button>
      <span style={{ fontSize: 12, fontWeight: 600, color: '#334155', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {group.label}
      </span>
    </div>
  );
}
